import { useState, useEffect, useContext, useMemo } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { ENVMetaContext } from "../../App";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import {
  saveENVAmendApplications,
  saveENVApplications,
  SaveENVDraftApplications,
  labCalculateFee,
  getLabMaster,
} from "../../api/apimethods";
import { notify } from "../../utils";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { helper } from "../../utils/helper";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import Stepwizard from "./Helper/Stepwizard";
import PersonalInformation from "./Helper/ProfileInformation";
import {
  IENVRequest,
  defENVAmmendAppStatus,
  defENVAmmendRowAppStatus,
  defENVAppStatus,
  defENVExchangeAppStatus,
} from "../../typings/interfaces/Requests/ENVRequest";
import { ILabFeeLineItemInput } from "../../typings/interfaces/Requests/LabFeeLineItemInput";
import { ICalculateFeeResponseModel } from "../../typings/interfaces/Requests/CalculateFeeResponseModel";
import { TypeOfApplicationEnum } from "../../utils/enum";
import { IENVSamplesAndTests } from "../../typings/models/ENVSamplesandTests";
import { defaultAppContextData } from "../../services/appData";
import { useContextService } from "../../services";
import { ILabEnvFeeInput } from "../../typings/interfaces/Requests/LabEnvFeeInput";
import Loader from "../../components/molecules/Loader";
import { defAmendmentRaisedStage } from "../../typings/interfaces/Requests/AquaRequest";
interface UenEntry {
  uen: string;
  contractAmount: string;
  lowBalanceAmount: string;
}
const stepWizardConfig: IStepwizardProps = {
  currentStep: 4,
  steps: [
    {
      name: "Choose Application",
    },

    {
      name: "Samples & Tests",
    },
    {
      name: "Review",
    },
    {
      name: "Cost & Confirm",
    },
    {
      name: "Acknowledgement",
    },
  ],
};

function CAVSENVCostAndConfirm() {
  const navigate = useNavigate();
  const { getContextValueFromStorage } = useContextService();
  const [contextData] = useState(() =>
    getContextValueFromStorage(defaultAppContextData)
  );
  const [uenValues, setUenValues] = useState<UenEntry[]>([]);
  const [contractAmount, setContractAmount] = useState<number | null>(null);
  const [lowBalanceAmount, setLowBalanceAmount] = useState<number | null>(null);
  const user = contextData.user;
  const { ENVMeta } = useContext(ENVMetaContext);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [btnNameForDraft, setBtnNameForDraft] = useState<string>("");
  const { message } = notify();
  const [isCheckboxChecked, setIsCheckboxChecked] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [ModeOfPaymentErrMsg, setModeOfPaymentErrMsg] = useState("");
  const [feesAfterGST, setFeesAfterGST] = useState<number>(0);
  const actionedStatus = localStorage.getItem("psh-app-status");
  const { btnLoaderHandler, DraftbtnLoaderHandler } = helper();
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
  const [labEnvFees, setEnvLabFees] =
    useState<ICalculateFeeResponseModel | null>(null);
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [modeOfPayment, setModeOfPayment] = useState<string>(
    localStorage.getItem("modeOfPayment") || "Credit Card"
  );
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  let requestMeta: IENVRequest = ENVMeta.ENVMeta;
  const getUserInfo = localStorage.getItem("app-data");
  const userInfo = JSON.parse(getUserInfo || "");
  let NRIC = userInfo?.user?.idNo || null;
  let UEN = userInfo?.user?.uen || null;
  let role = userInfo?.user?.role || "";
  const customerIdentifier = role === "CorpPass" ? UEN : NRIC;
  const handleDraftLoader = (
    enableLoader: boolean,
    btnNameForDraft: string
  ) => {
    setBtnNameForDraft(enableLoader ? btnNameForDraft : "");
  };
  const stripHtmlTags = (str: string) => {
    return str.replace(/<\/?([a-z][a-z0-9]*)\b[^>]*>/gi, "");
  };
  useEffect(() => {
    btnLoaderHandler(btnNameForLoader ? true : false);
  }, [btnNameForLoader]);
  useEffect(() => {
    DraftbtnLoaderHandler(btnNameForDraft ? true : false);
  }, [btnNameForDraft]);

  const handlePreviousClick = () => {
    navigate("/env-review");
  };
  const formatDescription = (description: string | null) => {
    if (!description) return "";
    return description
      .replace(/<i>/g, "<em>")
      .replace(/<\/i>/g, "</em>")
      .replace(/<li>/g, "<i>")
      .replace(/<\/li>/g, "</i>");
  };
  useEffect(() => {
    fetchAndSetMasterData();
  }, []);
  const fetchAndSetMasterData = async () => {
    setPageLoader(true);

    try {
      const labMasterResponse = await getLabMaster();
      if (labMasterResponse?.status === 200) {
        const masters = labMasterResponse.data.masters;

        if (masters?.exchangeOfServices) {
          setUenValues(masters.exchangeOfServices);
        } else {
          console.warn("No exchangeOfServices found in the master data.");
        }
      } else {
        console.error(
          `Failed to fetch lab master data: ${labMasterResponse?.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching lab master data:", error);
    } finally {
      setPageLoader(false);
    }
  };
  const memoizedUenValues = useMemo(() => uenValues, [uenValues]);

  useEffect(() => {
    const matchedData = memoizedUenValues.find(
      (entry: UenEntry) => entry.uen === customerIdentifier
    );

    if (matchedData) {
      const amount = parseFloat(matchedData.contractAmount);
      const lowamount = parseFloat(matchedData.lowBalanceAmount);
      if (contractAmount !== amount) {
        setContractAmount(amount);
        setLowBalanceAmount(lowamount);
      }
    } else {
      if (contractAmount !== null) {
        setContractAmount(null);
        setLowBalanceAmount(null);
      }
    }
  }, [memoizedUenValues, contractAmount, lowBalanceAmount]);

  useEffect(() => {
    if (modeOfPayment) {
      setErrorMessage("");
      const timeoutId = setTimeout(() => {
        fetchLabCalculateFee();
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  }, [modeOfPayment]);

  const fetchLabCalculateFee = async () => {
    try {
      let requestMeta: IENVRequest = ENVMeta.ENVMeta;
      let applicationTypeText = "New";
      if (requestMeta.actionStatus === TypeOfApplicationEnum.amendment) {
        applicationTypeText = TypeOfApplicationEnum.amendment;
      }

      let sampleDataMeta: IENVSamplesAndTests[] = [];

      if (Object.keys(requestMeta)?.length) {
        sampleDataMeta = requestMeta?.labENVSampleTests;
      }

      let feeLineItems: ILabFeeLineItemInput[] = [];
      if (sampleDataMeta.length) {
        sampleDataMeta.forEach(function (v) {
          const sampleRowId: number =
            typeof v?.sampleRowId === "number" ? v?.sampleRowId : 0;
          v?.labENVTestDetails?.forEach((element) => {
            const testRowId = element?.rowId || 0;
            let ILabFeeLineItemInput: ILabFeeLineItemInput = {
              testCode: stripHtmlTags(element?.testDescription || ""),
              testName: stripHtmlTags(element?.testDescription || ""),
              packageCode: "",
              packageName: "",
              sampleName: v?.sampleMarking || "",
              sampleDescription: v?.sampleMarking || "",
              testCount: element?.nooftestsrequired ?? 1,
              testrowId: testRowId,
              sampleRowId: sampleRowId,
            };
            feeLineItems.push(ILabFeeLineItemInput);
          });
        });
      }

      let labApplicationchangedDetails = null;
      let labChangedPreference = null;
      let labchangedSampleTestDetails = null;

      if (
        actionedStatus === "Report Released" ||
        actionedStatus === "Application Closed" ||
        actionedStatus === "Report Hard Copy Collected"
      ) {
        labApplicationchangedDetails =
          requestMeta.labApplicationchangedDetails || null;
        labChangedPreference = requestMeta.labChangedPreference || null;
        labchangedSampleTestDetails =
          requestMeta.labchangedSampleTestDetails?.map(
            ({ labENVTestDetails, ...rest }) => ({
              ...rest,
              labENVTestDetails: [],
            })
          ) || null;
      }

      let labFeeInput: ILabEnvFeeInput = {
        transactionType: 1,
        purposeCode: "ENV",
        typeofService: "CAVS Laboratory Services",
        applicationNumber: requestMeta?.applicationNumber || "",
        applicationType: applicationTypeText,
        feeLineItems: feeLineItems,
        labApplicationchangedDetails,
        labChangedPreference,
        labchangedSampleTestDetails,
      };

      const response = await labCalculateFee(labFeeInput);
      setEnvLabFees(response.data);
      setFeesAfterGST(response.data?.feesAfterGST || 0);

      if (
        modeOfPayment === "Exchange of Service agreement" &&
        contractAmount !== null &&
        response.data?.feesAfterGST &&
        response.data?.feesAfterGST >= contractAmount
      ) {
        setIsButtonVisible(false);
        message(
          NotifyType.Error,
          "The fees exceed the contract amount. Please review the charges."
        );
        setModeOfPaymentErrMsg(
          `${ErrMsg.ExchangeofServiceErrMsg} ${labEnvFees?.feesAfterGST}`
        );
      } else {
        setIsButtonVisible(true);
        setModeOfPaymentErrMsg("");
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
      message(
        NotifyType.Error,
        "An error occurred while calculating the fees. Please try again."
      );
    }
  };

  const handleSubmit = async () => {
    try {
      if (!isCheckboxChecked) {
        message(NotifyType.Error, "Please check the Acknowledgement checkbox.");
        return;
      }
      handleLoader(true, "submit-req");
      const profileInfo = localStorage.getItem("profile-info");
      const personalInfoDetails = profileInfo ? JSON.parse(profileInfo) : {};
      const modeOfPayment = localStorage.getItem("modeOfPayment");
      let requestMeta: IENVRequest = {
        ...ENVMeta.ENVMeta,
        labENVPersonalInfoDetails: personalInfoDetails,
      };

      const purposeOfTest = requestMeta?.labENVApplicationDetails?.purposeTest;

      if (purposeOfTest === 1 && modeOfPayment !== "Biosurveillance") {
        setErrorMessage(ErrMsg.BiosurveillancepaymentmodeErrMsg);
        message(NotifyType.Error, "Please check the error message.");
        handleLoader(false, "submit-req");
        return;
      }

      if (modeOfPayment === "Biosurveillance" && purposeOfTest !== 1) {
        setErrorMessage(ErrMsg.BiosurveillancePurposeofTestErrMsg);
        message(NotifyType.Error, "Please check the error message.");
        handleLoader(false, "submit-req");
        return;
      }
      setErrorMessage("");
      if (
        modeOfPayment === "Exchange of Service agreement" &&
        contractAmount !== null &&
        labEnvFees?.feesAfterGST &&
        labEnvFees?.feesAfterGST >= contractAmount
      ) {
        setIsButtonVisible(false);
        message(
          NotifyType.Error,
          "The fees exceed the contract amount. Please review the charges."
        );

        setModeOfPaymentErrMsg(
          `${ErrMsg.ExchangeofServiceErrMsg} ${labEnvFees?.feesAfterGST}`
        );
        handleLoader(false, "submit-req");
        return;
      } else {
        setIsButtonVisible(true);
        setModeOfPaymentErrMsg("");
      }
      if (Object.keys(requestMeta).length > 0) {
        const actionedStatus = localStorage.getItem("psh-app-status");
        const isExchangeOfService =
          requestMeta.labENVPersonalInfoDetails.modeOfPayment ===
            "Exchange of Service agreement" ||
          requestMeta.labENVPersonalInfoDetails.modeOfPayment ===
            "Biosurveillance";
        let response1;
        let amendmentRaisedStage: number | null = null;

        if (actionedStatus && actionedStatus in defAmendmentRaisedStage) {
          amendmentRaisedStage =
            defAmendmentRaisedStage[
              actionedStatus as keyof typeof defAmendmentRaisedStage
            ];
        }

        if (requestMeta.labENVSampleTests) {
          requestMeta.labENVSampleTests.forEach((sample: any) => {
            if (sample.labENVTestDetails) {
              sample.labENVTestDetails.forEach((test: any) => {
                test.testDescription = stripHtmlTags(test.testDescription);
              });
            }
          });
        }
        if (requestMeta.actionStatus === TypeOfApplicationEnum.draft) {
          requestMeta.applicationNumber = requestMeta.applicationNumber || "";
        }

        if (requestMeta.actionStatus === TypeOfApplicationEnum.submit) {
          delete requestMeta.applicationNumber;
        }

        if (requestMeta.actionStatus === TypeOfApplicationEnum.amendment) {
          let labENVApplicationStatus;

          const hasRowIdMismatch = requestMeta.labENVSampleTests.some(
            (sample) =>
              Number(sample?.rowId ?? 0) > Number(sample?.sampleCaseRowId ?? 0)
          );

          if (
            (actionedStatus === "Testing In Progress" ||
              actionedStatus === "Sample(s) Received") &&
            hasRowIdMismatch
          ) {
            labENVApplicationStatus = defENVAmmendRowAppStatus;
          } else {
            labENVApplicationStatus = defENVAmmendAppStatus;
          }
          requestMeta.labENVApplicationStatus = {
            ...labENVApplicationStatus,
            amendmentRaisedStage: amendmentRaisedStage,
            actionedStatus: actionedStatus || "",
          };
          requestMeta.applicationNumber = requestMeta.applicationNumber || "";
          response1 = await saveENVAmendApplications(requestMeta);
        } else {
          requestMeta.labENVApplicationStatus = isExchangeOfService
            ? defENVExchangeAppStatus
            : defENVAppStatus;

          response1 = await saveENVApplications(requestMeta);
        }

        if (response1.status === 200) {
          const {
            ENVApplicationNumber,
            ApplicationDate,
            ApplicantName,
            ApplicantEmail,
          } = JSON.parse(response1.data as any);
          const acknowledgmentNumber = ENVApplicationNumber;
          const applicationDate = ApplicationDate;
          const applicantName = ApplicantName;
          const applicantEmail = ApplicantEmail;
          const balanceAmount =
            contractAmount !== null ? contractAmount - feesAfterGST : 0;
          const lowBalancedAmount = lowBalanceAmount;
          message(NotifyType.Success, "Request Submitted Successfully");
          ENVMeta.updateENVMeta({});
          localStorage.removeItem("profile-info");
          localStorage.removeItem("psh-app-applicationNum");
          localStorage.removeItem("ismetadata");
          localStorage.removeItem("psh-app-status");
          setTimeout(() => {
            handleLoader(false, "submit-req");
            navigate("/env-acknowledgement", {
              state: {
                acknowledgmentNumber,
                applicationDate,
                applicantName,
                applicantEmail,
                balanceAmount:
                  modeOfPayment === "Exchange of Service agreement"
                    ? balanceAmount
                    : null,
                lowBalancedAmount:
                  modeOfPayment === "Exchange of Service agreement"
                    ? lowBalancedAmount
                    : null,
              },
            });
          }, 5000);
        } else {
          message(NotifyType.Error, "Issue on the request submission.");
          handleLoader(false, "submit-req");
        }
      } else {
        message(NotifyType.Error, "Incomplete data. Cannot submit request.");
        handleLoader(false, "submit-req");
      }
    } catch (error: any) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
      handleLoader(false, "submit-req");
    }
  };
  const handleSaveDraftClick = async () => {
    try {
      handleDraftLoader(true, "submit-request");
      const profileInfo = localStorage.getItem("profile-info");
      const personalInfoDetails = profileInfo ? JSON.parse(profileInfo) : {};
      const meta: IENVRequest = {
        ...ENVMeta.ENVMeta,
        labENVPersonalInfoDetails: personalInfoDetails,
      };
      if (meta.labENVSampleTests) {
        meta.labENVSampleTests.forEach((sample: any) => {
          if (sample.labENVTestDetails) {
            sample.labENVTestDetails.forEach((test: any) => {
              test.testDescription = stripHtmlTags(test.testDescription);
            });
          }
        });
      }

      const response1 = await SaveENVDraftApplications(meta);
      if (response1.status === 200) {
        const acknowledgmentNumberMatch = response1.data?.match(
          /"ENVDraftApplicationNumber":"(\w+)"/
        );

        const acknowledgmentNumber = acknowledgmentNumberMatch
          ? acknowledgmentNumberMatch[1]
          : undefined;
        if (acknowledgmentNumber) {
          meta.applicationNumber = acknowledgmentNumber;
          if (meta.actionStatus === TypeOfApplicationEnum.submit) {
            meta.actionStatus = "Draft";
          }
          ENVMeta.updateENVMeta(meta);
        }

        message(
          NotifyType.Success,
          acknowledgmentNumber
            ? `Draft Saved Successfully`
            : "Draft Saved Successfully"
        );

        setAcknowledgmentMessage(
          acknowledgmentNumber ? `${acknowledgmentNumber}` : ""
        );
        localStorage.removeItem("psh-app-applicationNum");
        localStorage.removeItem("ismetadata");
        localStorage.removeItem("psh-app-status");
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleDraftLoader(false, "submit-request");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleDraftLoader(false, "");
    }
  };
  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab"> Application for Laboratory Testing </div>
        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <div className="row setup-content" id="step-4">
          {pageLoader ? (
            <Loader />
          ) : (
            <div className="col-md-12">
              <div className="tab-wizard-content">
                {acknowledgmentMessage && (
                  <div className="info-content">
                    <div className="att">
                      <h3>Attention</h3>
                      <br />
                      <p className="attention">
                        {">"} Application has been successfully Saved as Draft.
                        Service Acknowledgement Number: &nbsp;
                        {acknowledgmentNumber ? acknowledgmentNumber : ""}
                      </p>
                      {acknowledgmentMessage}
                    </div>
                  </div>
                )}
                {errorMessage && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{errorMessage}</center>
                      </div>
                    </div>
                  </div>
                )}
                {ModeOfPaymentErrMsg && (
                  <div className="info-content">
                    <div className="att">
                      <br />
                      <div className="text-danger">
                        <center>{ModeOfPaymentErrMsg}</center>
                      </div>
                    </div>
                  </div>
                )}
                <PersonalInformation onModeOfPaymentChange={setModeOfPayment} />
              </div>
            </div>
          )}
        </div>
        <div className="personal-info">
          <div className="info-heading">
            <p className="float-end pro-cnt">
              <span className="star-red">*</span>This is an Estimated cost.
              Total amount payable to be confirmed upon sample submission.
            </p>
            <h2>Estimation Of Cost</h2>
          </div>

          <div className="info-content ">
            <div className="table-responsive last-bg mt-2 mb-2">
              <table className="table table-striped product_table start_table table-02">
                <thead>
                  <tr>
                    <th>S/N</th>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Quantity</th>
                    {user?.role !== "ForeignerLogin" && (
                      <th>Unit Price (S$)</th>
                    )}
                    {user?.role !== "ForeignerLogin" && (
                      <th>GST Amount (S$)</th>
                    )}
                    <th>Amount (S$)</th>
                  </tr>
                </thead>
                <tbody>
                  {/* {actionedStatus !== "Pending Sample(s)" && (
                    <>
                      {labEnvFees?.originalfeeLineItemsResponse &&
                        labEnvFees.originalfeeLineItemsResponse.length > 0 && (
                          <>
                            {labEnvFees?.applicationType ===
                              TypeOfApplicationEnum.amendment && (
                              <tr>
                                <td className="fnt-wgg" colSpan={7}>
                                  Original
                                </td>
                              </tr>
                            )}
                            {labEnvFees?.originalfeeLineItemsResponse?.map(
                              (item, index) => (
                                <tr key={index}>
                                  <td>{item.sNo}</td>
                                  <td
                                    dangerouslySetInnerHTML={{
                                      __html: formatDescription(
                                        item.description2
                                          ? item.description2
                                          : item.name
                                      ),
                                    }}
                                  ></td>
                                  <td>{item.description}</td>
                                  <td>{item.quantity}</td>
                                  {user?.role !== "ForeignerLogin" && (
                                    <td>{item.unitAmt?.toFixed(2)}</td>
                                  )}
                                  {user?.role !== "ForeignerLogin" && (
                                    <td>{item.gstAmt?.toFixed(2)}</td>
                                  )}
                                  <td>{item.netAmt?.toFixed(2)}</td>
                                </tr>
                              )
                            )}
                          </>
                        )}
                    </>
                  )} */}
                  {/* {actionedStatus !== "Pending Sample(s)" && (
                    <>
                      {labEnvFees?.deletedfeeLineItemsResponse &&
                        labEnvFees.deletedfeeLineItemsResponse.length > 0 && (
                          <>
                            {labEnvFees?.applicationType ===
                              TypeOfApplicationEnum.amendment && (
                              <tr>
                                <td className="fnt-wgg" colSpan={7}>
                                  Removed
                                </td>
                              </tr>
                            )}
                            {labEnvFees?.deletedfeeLineItemsResponse?.map(
                              (item, index) => (
                                <tr key={index}>
                                  <td>{item.sNo}</td>
                                  <td
                                    dangerouslySetInnerHTML={{
                                      __html: formatDescription(
                                        item.description2
                                          ? item.description2
                                          : item.name
                                      ),
                                    }}
                                  ></td>
                                  <td>{item.description}</td>
                                  <td>{item.quantity}</td>
                                  {user?.role !== "ForeignerLogin" && (
                                    <td>{item.unitAmt?.toFixed(2)}</td>
                                  )}
                                  {user?.role !== "ForeignerLogin" && (
                                    <td>{item.gstAmt?.toFixed(2)}</td>
                                  )}
                                  <td>{item.netAmt?.toFixed(2)}</td>
                                </tr>
                              )
                            )}
                          </>
                        )}
                    </>
                  )} */}
                  {labEnvFees?.feeLineItemsResponse &&
                    labEnvFees.feeLineItemsResponse.length > 0 && (
                      <>
                        {labEnvFees?.applicationType ===
                          TypeOfApplicationEnum.amendment && labEnvFees?.feesBeforeGST > 0 && (
                          <tr>
                            <td className="fnt-wgg" colSpan={7}>
                              Outstanding Payment
                            </td>
                          </tr>
                        )}

                        {labEnvFees?.feeLineItemsResponse?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item.sNo}</td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: formatDescription(
                                    item.description2
                                      ? item.description2
                                      : item.name
                                  ),
                                }}
                              ></td>
                              <td>{item.description}</td>
                              <td>{item.quantity}</td>
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.unitAmt?.toFixed(2)}</td>
                              )}
                              {user?.role !== "ForeignerLogin" && (
                                <td>{item.gstAmt?.toFixed(2)}</td>
                              )}
                              <td>{item.netAmt?.toFixed(2)}</td>
                            </tr>
                          )
                        )}
                      </>
                    )}

                  {user?.role !== "ForeignerLogin" && (
                    <tr>
                      <td className="fnt-wg total-fees-payable" colSpan={6}>
                        Total Fees Payable (Before GST)
                      </td>
                      <td className="total-fees-payable">
                        {labEnvFees?.feesBeforeGST?.toFixed(2)}
                      </td>
                    </tr>
                  )}
                  <tr>
                    <td
                      className="fnt-wg"
                      colSpan={user?.role === "ForeignerLogin" ? 4 : 6}
                    >
                      {user?.role !== "ForeignerLogin"
                        ? "Total GST Payable"
                        : "Total Fees Payable"}
                    </td>
                    <td>
                      {user?.role !== "ForeignerLogin"
                        ? labEnvFees?.totalGST?.toFixed(2)
                        : labEnvFees?.feesAfterGST?.toFixed(2)}
                    </td>
                  </tr>
                  {user?.role !== "ForeignerLogin" && (
                    <tr>
                      <td className="fnt-wg" colSpan={6}>
                        Total Fees Payable (After GST)
                      </td>
                      <td>{labEnvFees?.feesAfterGST?.toFixed(2)}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <p>Acknowledgement</p>
            <div className="form-check">
              <input
                className="form-check-input mt-2"
                type="checkbox"
                checked={isCheckboxChecked}
                id="flexCheckDefault"
                onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
              />
              <label className="form-check-label" htmlFor="flexCheckDefault">
                Please check that your laboratory services application is in
                order before you submit it. There will be no refund once payment
                is made.
              </label>
            </div>
          </div>
        </div>
        <div className="text-end mt-3 mb-3">
          {requestMeta.actionStatus !== TypeOfApplicationEnum.amendment && (
            <button
              className="btn btn-d btn-secondary px-4"
              onClick={handleSaveDraftClick}
              disabled={btnNameForDraft === "submit-request"}
            >
              Save Draft
            </button>
          )}

          <button
            className="btn btn-d btn-secondary px-4"
            onClick={handlePreviousClick}
          >
            Previous
          </button>
          {isButtonVisible && (
            <button
              className="btn btn-d btn-primary"
              type="button"
              name="submit-req"
              onClick={handleSubmit}
            >
              Submit
              {btnNameForLoader == "submit-req" ? (
                <Spinner
                  className="btn-spinner"
                  animation="border"
                  variant="light"
                />
              ) : (
                ""
              )}
            </button>
          )}
        </div>
      </Container>
      <Footer />
    </>
  );
}
export default CAVSENVCostAndConfirm;
